module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_50-Red-e3d00810e468315536a9b1f2266883aa.png";